import { zonoApi } from '../api';
import {
  CustomerLedgerRequest,
  CustomerLedgerResponse,
  DownloadLedgerRequest,
  GetLedgerTrailBalanceSummaryRequest,
  GetLedgerTrailBalanceSummaryResponse,
} from './ledger-model';

export const ledgerApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerLedger: builder.query<
      CustomerLedgerResponse,
      CustomerLedgerRequest
    >({
      query(customerLedgerRequest: CustomerLedgerRequest) {
        return {
          url: `invoiceservice/partyAccountBook/list`,
          method: 'GET',
          params: customerLedgerRequest,
        };
      },
    }),
    getLedgerTrailBalanceSummary: builder.query<
      GetLedgerTrailBalanceSummaryResponse,
      GetLedgerTrailBalanceSummaryRequest
    >({
      query(arg) {
        return {
          url: `invoiceservice/trial-balance/summary/${arg?.sellerWorkspaceId}`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    downloadLedger: builder.query<any, DownloadLedgerRequest>({
      query(params: DownloadLedgerRequest) {
        return {
          url: `invoiceservice/partyaccountbook/list/download`,
          method: 'GET',
          params: params,
          responseHandler: (response) => response.arrayBuffer(),
        };
      },
    }),
  }),
});

export const {
  useLazyGetCustomerLedgerQuery,
  useLazyGetLedgerTrailBalanceSummaryQuery,
  useLazyDownloadLedgerQuery,
} = ledgerApi;
